import * as React from "react";
import { Divider } from "antd";
import { useCpFormValue } from "../../../gvc/testNewForm/utils";
import { CpSwitch } from "../../../gvc/testNewForm/CpSwitch";
import { CpInput } from "../../../gvc/testNewForm/CpInput";
import { CpLabel } from "../../../gvc/testNewForm/CpLabel";
import { CpFormItem } from "../../../gvc/testNewForm/CpFormItem";
import { CpArrayString } from "../../../gvc/testNewForm/CpArrayString";
import { CpErrorWarningArray } from "../../../gvc/testNewForm/CpErrorWarningArray";
import { CpLabelDirtyIndicator } from "../../../gvc/testNewForm/CpLabelDirtyIndicator";
import { Only } from "../only";

interface Props {
  index: number;
}
export const WorkloadContainerMetrics: React.FC<Props> = React.memo(({ index }) => {
  const isEnabled = useCpFormValue(`containers.${index}.metrics.isEnabled`);

  return (
    <>
      <Divider orientation={`left`} orientationMargin={0}>
        Metrics
      </Divider>
      <CpFormItem>
        <div className="flex items-center gap-2">
          <CpLabel name={`containers.${index}.metrics.isEnabled`}>
            Enable Custom Metrics
            <Only name={`meta.isCreate`} checkFn={(v) => v === false}>
              <CpLabelDirtyIndicator name={`containers.${index}.metrics.isEnabled`} />
            </Only>
          </CpLabel>
          <CpSwitch name={`containers.${index}.metrics.isEnabled`} />
        </div>
      </CpFormItem>
      {isEnabled ? (
        <>
          <CpFormItem>
            <div className="flex items-start gap-2">
              <div className="flex flex-col">
                <CpLabel name={`containers.${index}.metrics.path`}>
                  Path
                  <Only name={`meta.isCreate`} checkFn={(v) => v === false}>
                    <CpLabelDirtyIndicator name={`containers.${index}.metrics.path`} />
                  </Only>
                </CpLabel>
                <CpInput name={`containers.${index}.metrics.path`} style={{ width: 400 }} />
              </div>
              <div className="flex flex-col">
                <CpLabel name={`containers.${index}.metrics.port`}>
                  Port
                  <Only name={`meta.isCreate`} checkFn={(v) => v === false}>
                    <CpLabelDirtyIndicator name={`containers.${index}.metrics.port`} />
                  </Only>
                </CpLabel>
                <CpInput name={`containers.${index}.metrics.port`} style={{ width: 140 }} />
              </div>
            </div>
            <CpErrorWarningArray names={[`containers.${index}.metrics.path`, `containers.${index}.metrics.port`]} />
          </CpFormItem>
          <div style={{ maxWidth: 600 }}>
            <CpArrayString
              label="Drop Metrics"
              name={`containers.${index}.metrics.dropMetrics`}
              dirtyIndicator={{
                isEnabled: true,
                only: {
                  name: "meta.isCreate",
                  checkFn: (v) => v === false,
                },
              }}
            />
          </div>
        </>
      ) : null}
    </>
  );
});
